import { createFileRoute } from '@tanstack/react-router';
import { KeysTopic } from '../screens/company/topics/KeysTopic';

export const Route = createFileRoute('/t/$tenant/settings/developers/keys')({
  component: KeysTopic,
});
